export const state = () => ({
    coinHistories: { data: [] },
    coinHistoryReport: { data: [] },
})

export const actions = {
    async getCoinHistories({ commit }, data) {
        const params = {
            ...data,
        }
        params.start_date = params.start_date + ' 00:00:00'
        const endDate = params.end_date + ' 23:59:59'
        params.end_date = this.$dayjs(endDate)
            .add(1, 'second')
            .format('YYYY-MM-DD HH:mm:ss')

        await this.$axios
            .get('/players-reward/mission-control/coin-history', { params })
            .then((data) => {
                commit('setCoinHistories', data.data)
            })
            .catch((_) => {
                return false
            })
    },
    async getCoinHistoryReports({ commit }, data) {
        const params = {
            ...data,
        }

        params.start_date = params.start_date + ' 00:00:00'
        const endDate = params.end_date + ' 23:59:59'
        params.end_date = this.$dayjs(endDate)
            .add(1, 'second')
            .format('YYYY-MM-DD HH:mm:ss')
        await this.$axios
            .get('/players-reward/mission-control/coin-history/report', {
                params,
            })
            .then((data) => {
                commit('setCoinHistoryReport', data.data)
            })
            .catch((_) => {
                return false
            })
    },
}

export const mutations = {
    setCoinHistories(state, data) {
        state.coinHistories = data
    },
    setCoinHistoryReport(state, data) {
        state.coinHistoryReport = data
    },
}
